// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

*{
  --tw-border-opacity: 1;
  border-color: hsl(var(--border) / var(--tw-border-opacity, 1));
    box-sizing: border-box;
}

body{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--background) / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.relative{
  position: relative;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-6{
  margin-right: 1.5rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.size-3{
  width: 0.75rem;
  height: 0.75rem;
}
.size-3\\.5{
  width: 0.875rem;
  height: 0.875rem;
}
.size-4{
  width: 1rem;
  height: 1rem;
}
.size-6{
  width: 1.5rem;
  height: 1.5rem;
}
.size-7{
  width: 1.75rem;
  height: 1.75rem;
}
.size-8{
  width: 2rem;
  height: 2rem;
}
.size-9{
  width: 2.25rem;
  height: 2.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-full{
  height: 100%;
}
.w-\\[10px\\]{
  width: 10px;
}
.w-full{
  width: 100%;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[5\\.5rem\\]{
  min-width: 5.5rem;
}
.flex-1{
  flex: 1 1 0%;
}
.shrink-0{
  flex-shrink: 0;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.flex-col{
  flex-direction: column;
}
.items-center{
  align-items: center;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-5{
  gap: 1.25rem;
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: hsl(var(--border) / var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-y-auto{
  overflow-y: auto;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-border{
  --tw-border-opacity: 1;
  border-color: hsl(var(--border) / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.bg-accent{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--accent) / var(--tw-bg-opacity, 1));
}
.bg-background{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--background) / var(--tw-bg-opacity, 1));
}
.bg-card{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--card) / var(--tw-bg-opacity, 1));
}
.bg-destructive\\/10{
  background-color: hsl(var(--destructive) / 0.1);
}
.bg-muted{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1));
}
.bg-muted\\/30{
  background-color: hsl(var(--muted) / 0.3);
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--primary) / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--secondary) / var(--tw-bg-opacity, 1));
}
.p-3{
  padding: 0.75rem;
}
.p-6{
  padding: 1.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-3{
  padding-top: 0.75rem;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-medium{
  font-weight: 500;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.italic{
  font-style: italic;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.text-card-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--card-foreground) / var(--tw-text-opacity, 1));
}
.text-destructive{
  --tw-text-opacity: 1;
  color: hsl(var(--destructive) / var(--tw-text-opacity, 1));
}
.text-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--muted-foreground) / var(--tw-text-opacity, 1));
}
.text-muted-foreground\\/70{
  color: hsl(var(--muted-foreground) / 0.7);
}
.text-primary{
  --tw-text-opacity: 1;
  color: hsl(var(--primary) / var(--tw-text-opacity, 1));
}
.text-primary-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--primary-foreground) / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  --tw-text-opacity: 1;
  color: hsl(var(--secondary-foreground) / var(--tw-text-opacity, 1));
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[hsl\\(var\\(--ring\\)\\)\\]{
  --tw-ring-color: hsl(var(--ring));
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

:root {
  --background: 210 38% 99%;
  --foreground: 222 47% 11%;
  --card: 0 0% 100%;
  --card-foreground: 222 47% 11%;
  --popover: 0 0% 100%;
  --popover-foreground: 222 47% 11%;
  --primary: 203 41% 41%;
  --primary-foreground: 0 0% 100%;
  --secondary: 210 33% 97%;
  --secondary-foreground: 222 47% 11%;
  --muted: 210 33% 97%;
  --muted-foreground: 215 16% 47%;
  --accent: 212 78% 95%;
  --accent-foreground: 222 47% 11%;
  --destructive: 0 84% 60%;
  --destructive-foreground: 210 40% 98%;
  --border: 214 24% 88%;
  --input: 214 24% 88%;
  --ring: 203 41% 41%;
  --radius: 1rem;

  /* Gridrive brand palette (teal → navy) */
  --brand-light: #5d98b6;
  --brand-main: #3d7292;
  --brand-dark: #1b3e5a;
  --brand-gradient: linear-gradient(
    135deg,
    var(--brand-light) 0%,
    var(--brand-main) 50%,
    var(--brand-dark) 100%
  );
  --brand-soft: rgba(61, 114, 146, 0.12);
  --brand-soft-strong: rgba(61, 114, 146, 0.18);
  --brand-pulse: rgba(61, 114, 146, 0.45);
}

.dark {
  --background: 222 47% 7%;
  --foreground: 210 40% 96%;
  --card: 222 47% 10%;
  --card-foreground: 210 40% 96%;
  --popover: 222 47% 10%;
  --popover-foreground: 210 40% 96%;
  --primary: 201 42% 54%;
  --primary-foreground: 0 0% 100%;
  --secondary: 217 33% 17%;
  --secondary-foreground: 210 40% 96%;
  --muted: 217 33% 17%;
  --muted-foreground: 215 20% 65%;
  --accent: 217 33% 17%;
  --accent-foreground: 210 40% 96%;
  --destructive: 0 63% 31%;
  --destructive-foreground: 210 40% 98%;
  --border: 217 33% 20%;
  --input: 217 33% 20%;
  --ring: 201 42% 54%;
}

html,
body,
#root {
  height: 100%;
  margin: 0;
}

body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

button,
input,
textarea,
select {
  font: inherit;
}

::-moz-placeholder {
  color: hsl(var(--muted-foreground));
  opacity: 1;
}

::placeholder {
  color: hsl(var(--muted-foreground));
  opacity: 1;
}

::-moz-selection {
  background: rgba(59, 130, 246, 0.18);
}

::selection {
  background: rgba(59, 130, 246, 0.18);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.45);
  border: 2px solid transparent;
  border-radius: 9999px;
  background-clip: padding-box;
}

.dark ::-webkit-scrollbar-thumb {
  background: rgba(71, 85, 105, 0.6);
  background-clip: padding-box;
}

/* ── Split layout: table (top) + chat (bottom) ── */
.setup-table-region {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.setup-table-region.setup-table-split {
  flex: none;
  max-height: 55%;
  border-bottom: 1px solid hsl(var(--border));
}

.setup-chat-region {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.setup-table-region::-webkit-scrollbar {
  width: 4px;
}

.setup-table-region::-webkit-scrollbar-track {
  background: transparent;
}

.setup-table-region::-webkit-scrollbar-thumb {
  background: hsl(var(--border));
  border-radius: 2px;
}

.setup-table-region::-webkit-scrollbar-thumb:hover {
  background: hsl(var(--muted-foreground));
}

/* ── Chat message layout ── */
.message {
  display: flex;
  max-width: 100%;
}

.message.user {
  justify-content: flex-end;
}

.message.assistant {
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
}

.assistant-dot {
  width: 7px;
  height: 7px;
  min-width: 7px;
  border-radius: 50%;
  background: var(--brand-gradient);
  margin-top: 8px;
}

.assistant-dot.pulsing {
  animation: dotGlow 2.4s ease-in-out infinite;
}

@keyframes dotGlow {
  0%, 100% { opacity: 0.7; transform: scale(0.95); }
  50% { opacity: 1; transform: scale(1.08); }
}

.assistant-content {
  flex: 1;
  min-width: 0;
}

.bubble {
  max-width: 88%;
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.user-bubble {
  width: -moz-fit-content;
  width: fit-content;
  background: #f5f5f5;
  color: #111827;
  border-radius: 14px 14px 4px 14px;
  word-break: normal;
}

.dark .user-bubble {
  background: hsl(var(--secondary));
  color: hsl(var(--secondary-foreground));
}

.assistant-bubble {
  background: transparent;
  color: hsl(var(--foreground));
  padding: 2px 0;
}

.assistant-bubble > :first-child { margin-top: 0; }
.assistant-bubble > :last-child { margin-bottom: 0; }

.assistant-bubble h1,
.assistant-bubble h2,
.assistant-bubble h3,
.assistant-bubble h4,
.assistant-bubble h5,
.assistant-bubble h6 {
  margin: 14px 0 8px;
  line-height: 1.3;
  font-weight: 700;
}

.assistant-bubble h1 { font-size: 20px; }
.assistant-bubble h2 { font-size: 18px; }
.assistant-bubble h3 { font-size: 16px; }
.assistant-bubble h4,
.assistant-bubble h5,
.assistant-bubble h6 { font-size: 14px; }

.assistant-bubble p + p,
.assistant-bubble p + ul,
.assistant-bubble p + ol,
.assistant-bubble p + table,
.assistant-bubble p + blockquote,
.assistant-bubble ul + p,
.assistant-bubble ol + p,
.assistant-bubble table + p,
.assistant-bubble blockquote + p,
.assistant-bubble pre + p,
.assistant-bubble ul + pre,
.assistant-bubble ol + pre,
.assistant-bubble hr + p {
  margin-top: 10px;
}

.assistant-bubble ul,
.assistant-bubble ol {
  padding-left: 18px;
  margin: 8px 0 0;
}

.assistant-bubble li + li { margin-top: 4px; }

.assistant-bubble a {
  color: var(--brand-main);
  text-decoration: underline;
}

.assistant-bubble code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  background: rgba(17, 24, 39, 0.06);
  border-radius: 4px;
  padding: 1px 4px;
}

.assistant-bubble pre {
  margin: 10px 0 0;
  padding: 10px 12px;
  background: hsl(var(--card));
  border: 1px solid hsl(var(--border));
  border-radius: 8px;
  overflow-x: auto;
}

.assistant-bubble pre code {
  display: block;
  padding: 0;
  background: transparent;
  border-radius: 0;
  white-space: pre-wrap;
}

.assistant-bubble blockquote {
  margin: 10px 0 0;
  padding: 0 0 0 12px;
  border-left: 3px solid hsl(var(--border));
  color: hsl(var(--muted-foreground));
}

.assistant-bubble hr {
  margin: 12px 0;
  border: 0;
  border-top: 1px solid hsl(var(--border));
}

.assistant-bubble table {
  width: 100%;
  margin: 10px 0 0;
  border-collapse: collapse;
  background: hsl(var(--card));
  border: 1px solid hsl(var(--border));
  border-radius: 8px;
  overflow: hidden;
  display: table;
  max-width: 100%;
  table-layout: auto;
}

.assistant-bubble thead th {
  text-align: left;
  padding: 7px 8px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: hsl(var(--muted));
  border-bottom: 1px solid hsl(var(--border));
}

.assistant-bubble tbody td {
  padding: 7px 8px;
  vertical-align: top;
  border-bottom: 1px solid hsl(var(--border));
  font-size: 12px;
}

.assistant-bubble tbody tr:last-child td {
  border-bottom: none;
}

/* ── Cycling "thinking" word (shimmers in brand color) ── */
.thinking-word {
  display: inline-block;
  font-size: 13px;
  font-style: italic;
  padding: 2px 0;
  color: transparent;
  background: linear-gradient(
    90deg,
    var(--brand-main) 0%,
    var(--brand-main) 30%,
    #a8d4ec 50%,
    var(--brand-main) 70%,
    var(--brand-main) 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  animation: shimmer 2.5s ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/* ── Chat layout (message area grows, input pinned to bottom) ── */
.chat-container {
  position: relative;
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chat-empty-watermark {
  position: absolute;
  top: 40%;
  left: 50%;
  width: 96px;
  height: auto;
  transform: translate(-50%, -50%);
  opacity: 0.08;
  pointer-events: none;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.chat-messages {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow-y: auto;
  padding: 8px 10px;
}

/* ── Chat input (enclosed rounded box) ── */
.chat-input-area {
  flex-shrink: 0;
  padding: 8px 10px 10px;
  background: transparent;
}

.chat-input-enclosure {
  display: flex;
  flex-direction: column;
  background: hsl(var(--card));
  border: 1px solid hsl(var(--border));
  border-radius: 14px;
  padding: 6px 10px 6px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.chat-input-enclosure:focus-within {
  border-color: var(--brand-main);
  box-shadow: 0 0 0 3px var(--brand-soft);
}

.dark .chat-input-enclosure {
  background: hsl(var(--card));
}

.chat-input-box {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: transparent;
  padding: 0;
}

.chat-input-box textarea {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  font-family: inherit;
  color: hsl(var(--foreground));
  background: transparent;
  min-width: 0;
  resize: none;
  line-height: 1.5;
  max-height: 144px;
  overflow-y: hidden;
  padding: 6px 0;
}

.chat-input-box textarea::-moz-placeholder {
  color: hsl(var(--muted-foreground));
}

.chat-input-box textarea::placeholder {
  color: hsl(var(--muted-foreground));
}

.chat-input-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 2px 0 0;
  padding: 0;
}

.chat-input-workbook-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 180px;
  padding: 2px 8px;
  border-radius: 9999px;
  background: var(--brand-soft);
  color: var(--brand-main);
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  cursor: default;
}

.chat-input-mode-chip,
.chat-input-snapshot-chip,
.chat-input-template-context {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 150px;
  min-height: 22px;
  padding: 2px 8px;
  border: 1px solid hsl(var(--border));
  border-radius: 9999px;
  background: hsl(var(--background));
  color: hsl(var(--muted-foreground));
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
}

.chat-input-mode-chip {
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.chat-input-snapshot-chip {
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.chat-input-mode-picker {
  position: relative;
  display: inline-flex;
}

.chat-input-mode-chip:hover,
.chat-input-mode-chip.active,
.chat-input-snapshot-chip:hover {
  border-color: var(--brand-main);
  background: var(--brand-soft);
  color: var(--brand-main);
}

.chat-input-mode-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-input-mode-chevron {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.chat-input-mode-popover {
  position: absolute;
  left: 0;
  bottom: calc(100% + 8px);
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: -moz-max-content;
  width: max-content;
  min-width: 150px;
  max-width: calc(100vw - 32px);
  padding: 8px;
  border: 1px solid hsl(var(--border));
  border-radius: 12px;
  background: hsl(var(--popover));
  color: hsl(var(--popover-foreground));
  box-shadow: 0 16px 36px rgb(15 23 42 / 16%);
}

.chat-input-mode-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 34px;
  padding: 6px 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: hsl(var(--foreground));
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  text-align: left;
  white-space: nowrap;
}

.chat-input-mode-option:hover {
  background: hsl(var(--secondary));
}

.chat-input-mode-option[aria-checked="true"] {
  color: hsl(var(--foreground));
}

.chat-input-mode-option span {
  flex: 0 0 auto;
  min-width: 0;
}

.chat-input-mode-check {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-left: 4px;
}

.chat-input-template-context {
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-input-workbook-chip svg {
  flex-shrink: 0;
  display: block;
}

.chat-input-workbook-chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.chat-input-footer-left {
  display: flex;
  align-items: center;
  gap: 4px;
}

.chat-input-footer-right {
  display: flex;
  align-items: center;
  gap: 6px;
}

.chat-send-button {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 12px;
  background: var(--brand-gradient);
  color: #fff;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.15s ease, color 0.15s ease;
}

.chat-send-button:hover:not(:disabled) {
  filter: brightness(1.15);
}

.chat-send-button.is-stop {
  background: var(--brand-main);
  color: #fff;
}

/* Dim the arrow when textarea is empty (placeholder visible) */
.chat-input-area:has(textarea:-moz-placeholder)
  .chat-send-button:not(.is-stop):not(:disabled) {
  color: rgba(255, 255, 255, 0.45);
}
.chat-input-area:has(textarea:placeholder-shown)
  .chat-send-button:not(.is-stop):not(:disabled) {
  color: rgba(255, 255, 255, 0.45);
}

.chat-input-area:has(textarea:-moz-placeholder)
  .chat-send-button:not(.is-stop):not(:disabled):hover, .chat-input-area:has(textarea:-moz-placeholder)
  .chat-send-button:not(.is-stop):not(:disabled):active {
  filter: none;
  transform: none;
}

.chat-input-area:has(textarea:placeholder-shown)
  .chat-send-button:not(.is-stop):not(:disabled):hover,
.chat-input-area:has(textarea:placeholder-shown)
  .chat-send-button:not(.is-stop):not(:disabled):active {
  filter: none;
  transform: none;
}

.chat-send-button:active {
  transform: translateY(1px);
}

.chat-send-button:disabled {
  opacity: 0.45;
  cursor: default;
}

.chat-send-button svg {
  display: block;
}

/* ── Snapshot metric pill + inline name input ── */
.snapshot-metric-count {
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  background: var(--brand-gradient);
  padding: 4px 10px;
  border-radius: 9999px;
  white-space: nowrap;
}

.snapshot-name-input {
  width: 100px;
  padding: 3px 6px;
  border: 1px solid hsl(var(--border));
  border-radius: 6px;
  font-size: 11px;
  font-family: inherit;
  background: hsl(var(--card));
  color: hsl(var(--foreground));
}

.snapshot-name-input:focus {
  outline: none;
  border-color: var(--brand-main);
  box-shadow: 0 0 0 2px var(--brand-soft);
}

/* ── Generic icon buttons (gear, shortcuts, trace) ── */
.btn-icon {
  background: none;
  border: none;
  font-size: 14px;
  color: var(--brand-main);
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 6px;
  line-height: 1;
  transition: background 0.15s ease, color 0.15s ease;
}

.btn-icon:hover {
  color: var(--brand-dark);
  background: var(--brand-soft);
}

.btn-icon-gear {
  font-size: 18px;
  width: 32px;
  height: 32px;
}

.chat-input-footer .btn-icon-gear {
  font-size: 22px;
  width: 28px;
  height: 28px;
}

.btn-icon-shortcuts {
  background: none;
  border: none;
  cursor: pointer;
  color: hsl(var(--muted-foreground));
  padding: 4px 6px;
  border-radius: 6px;
  line-height: 1;
  transition: background 0.15s ease, color 0.15s ease;
}

.btn-icon-shortcuts svg {
  display: block;
  flex-shrink: 0;
}

.btn-icon-shortcuts:hover {
  color: var(--brand-main);
  background: var(--brand-soft);
}

.btn-trace {
  background: none;
  border: none;
  cursor: pointer;
  color: hsl(var(--muted-foreground));
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, color 0.15s ease;
}

.btn-trace:hover {
  color: var(--brand-main);
  background: var(--brand-soft);
}

.chat-input-footer .snapshot-name-input {
  width: 100px;
  padding: 3px 6px;
  font-size: 11px;
}

/* ── Fade-in reveal for finalized messages ── */
.bubble.fade-in-reveal {
  animation: fadeInReveal 0.4s ease-out both;
}

@keyframes fadeInReveal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* ── Interim bubble (status messages during multi-step ops) ── */
.interim-bubble {
  font-style: italic;
  color: hsl(var(--muted-foreground));
  font-size: 12px;
  padding: 2px 2px !important;
}

/* ── Metric Review Table (snapshot/scan results) ── */
.metric-table-wrapper {
  margin: 8px 0;
  max-width: 100%;
  overflow-x: auto;
  flex-shrink: 0;
}

.metric-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  background: hsl(var(--card));
  border: 1px solid hsl(var(--border));
  border-radius: 8px;
  overflow: hidden;
}

.metric-table thead th {
  text-align: left;
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 600;
  color: hsl(var(--muted-foreground));
  background: hsl(var(--muted));
  border-bottom: 1px solid hsl(var(--border));
  white-space: nowrap;
}

.metric-table tbody td {
  padding: 4px 6px;
  border-bottom: 1px solid hsl(var(--border));
  vertical-align: middle;
}

.metric-table tbody tr:last-child td {
  border-bottom: none;
}

.metric-table tbody tr:hover {
  background: hsl(var(--muted));
}

.mt-input {
  width: 100%;
  padding: 3px 5px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 12px;
  font-family: inherit;
  background: transparent;
  color: hsl(var(--foreground));
  transition: border-color 0.15s ease;
}

.mt-input:hover {
  border-color: hsl(var(--border));
}

.mt-input:focus {
  outline: none;
  border-color: var(--brand-main);
  background: hsl(var(--card));
  box-shadow: 0 0 0 2px var(--brand-soft);
}

.mt-input:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.mt-cell {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  max-width: 100px;
}

.mt-sheet {
  color: hsl(var(--muted-foreground));
  font-size: 11px;
  white-space: nowrap;
}

/* ── Scan confidence pill (replacement for inline tailwind on FieldRow) ── */
.scan-confidence-high {
  color: #16a34a;
}
.scan-confidence-medium {
  color: #d97706;
}
.scan-confidence-low {
  color: hsl(var(--muted-foreground));
}

/* ── Tabbed scan table: wrapper ── */
.tabbed-metric-table {
  margin: 4px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ── Sheet tabs (pill row) ── */
.sheet-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 2px 0 6px;
  border-bottom: 1px solid hsl(var(--border));
}

.sheet-tab {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: 1px solid transparent;
  color: hsl(var(--muted-foreground));
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 9999px;
  cursor: pointer;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.sheet-tab:hover {
  color: var(--brand-main);
  background: var(--brand-soft);
}

.sheet-tab.active {
  color: #fff;
  background: var(--brand-gradient);
  border-color: transparent;
}

/* ── Category section (Assumptions / Outputs) ── */
.category-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.category-header-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.category-header {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 2px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: hsl(var(--foreground));
  cursor: pointer;
  text-align: left;
  transition: color 0.15s ease;
}

.category-header:hover {
  color: var(--brand-main);
}

.category-arrow {
  color: hsl(var(--muted-foreground));
  transition: transform 0.15s ease;
}

.category-arrow.open {
  transform: rotate(90deg);
}

.category-label {
  letter-spacing: 0.01em;
}

.category-count {
  color: hsl(var(--muted-foreground));
  font-weight: 500;
  font-size: 11px;
}

.category-paint-button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: hsl(var(--muted-foreground));
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  padding: 3px;
  transition: background 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease, transform 0.15s ease;
  --color-1: #ef4444;
  --color-2: #f97316;
  --color-3: #22c55e;
  --color-4: #3b82f6;
  --color-5: #a855f7;
}

.category-paint-button.active {
  background: rgb(15 23 42 / 5%);
  box-shadow: 0 4px 10px rgb(15 23 42 / 12%);
}

.category-paint-button:not(.active) {
  opacity: 0.48;
}

.category-paint-button:hover {
  background: rgb(15 23 42 / 6%);
  opacity: 1;
  transform: translateY(-1px);
}

.category-paint-button.active:hover {
  box-shadow: 0 5px 12px rgb(15 23 42 / 18%);
}

.category-paint-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px hsl(var(--background)), 0 0 0 4px rgb(59 130 246 / 35%);
}

.category-paint-button:not(.active) .rainbow-brush-icon {
  filter: grayscale(0.85);
}

@keyframes rainbow-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Metric table: Name-column hint + action cell + add/delete buttons ── */
.metric-table th.mt-name,
.metric-table td.mt-name {
  min-width: 120px;
}

.metric-table th.mt-actions,
.metric-table td.mt-actions {
  width: 28px;
  text-align: right;
}

.mt-delete {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  color: hsl(var(--muted-foreground));
  padding: 4px;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: background 0.15s ease, color 0.15s ease;
}

.mt-delete:hover {
  color: hsl(var(--destructive));
  background: rgba(220, 38, 38, 0.08);
}

.mt-add-row {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  width: 100%;
  background: transparent;
  border: 1px dashed hsl(var(--border));
  border-radius: 8px;
  color: hsl(var(--muted-foreground));
  padding: 6px 8px;
  font-size: 11px;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.mt-add-row:hover {
  color: var(--brand-main);
  border-color: var(--brand-main);
  background: var(--brand-soft);
}

/* ── Inline template table inside template chat ── */
.template-table-artifact {
  width: 100%;
  min-width: 0;
}

.inline-fields-table {
  width: 100%;
  max-width: 100%;
  margin: 4px 0 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.inline-fields-table-wrapper {
  margin: 4px 0 8px;
}

.inline-metric-table {
  table-layout: fixed;
}

.inline-metric-table th,
.inline-metric-table td {
  overflow: hidden;
}

.metric-table th.mt-sheet-cell,
.metric-table td.mt-sheet-cell {
  min-width: 86px;
}

.template-table-summary {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid hsl(var(--border));
  border-radius: 8px;
  background: hsl(var(--muted));
  color: hsl(var(--muted-foreground));
  font-size: 11px;
  line-height: 1.3;
}

.template-table-summary span {
  white-space: nowrap;
}

.template-table-summary-preview {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.template-table-cancelled {
  width: -moz-fit-content;
  width: fit-content;
  margin: 2px 0 6px;
  color: hsl(var(--muted-foreground));
  font-size: 11px;
}

.chat-template-artifact {
  width: 100%;
  max-width: 100%;
  margin-top: 6px;
}

.chat-template-save-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.chat-template-name-input {
  min-width: 0;
  flex: 1;
  height: 30px;
  border: 1px solid hsl(var(--border));
  border-radius: 6px;
  background: hsl(var(--background));
  padding: 0 8px;
  color: hsl(var(--foreground));
  font-size: 12px;
}

.chat-template-save-button {
  flex-shrink: 0;
  height: 30px;
  border: none;
  border-radius: 6px;
  background: var(--brand-main);
  padding: 0 10px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.chat-template-save-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.chat-template-saved-label {
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 6px;
  color: hsl(var(--muted-foreground));
  font-size: 11px;
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:bottom-0::after{
  content: var(--tw-content);
  bottom: 0px;
}

.after\\:left-0::after{
  content: var(--tw-content);
  left: 0px;
}

.after\\:h-0\\.5::after{
  content: var(--tw-content);
  height: 0.125rem;
}

.after\\:w-full::after{
  content: var(--tw-content);
  width: 100%;
}

.after\\:rounded-full::after{
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:bg-foreground::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: hsl(var(--foreground) / var(--tw-bg-opacity, 1));
}

.hover\\:border-primary\\/40:hover{
  border-color: hsl(var(--primary) / 0.4);
}

.hover\\:bg-destructive\\/20:hover{
  background-color: hsl(var(--destructive) / 0.2);
}

.hover\\:bg-muted:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-muted\\/70:hover{
  background-color: hsl(var(--muted) / 0.7);
}

.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:text-foreground:hover{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.focus-visible\\:border-destructive\\/40:focus-visible{
  border-color: hsl(var(--destructive) / 0.4);
}

.focus-visible\\:border-primary:focus-visible{
  --tw-border-opacity: 1;
  border-color: hsl(var(--primary) / var(--tw-border-opacity, 1));
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-destructive\\/20:focus-visible{
  --tw-ring-color: hsl(var(--destructive) / 0.2);
}

.focus-visible\\:ring-primary\\/20:focus-visible{
  --tw-ring-color: hsl(var(--primary) / 0.2);
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.aria-expanded\\:border-primary\\/40[aria-expanded="true"]{
  border-color: hsl(var(--primary) / 0.4);
}

.aria-expanded\\:bg-muted[aria-expanded="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--muted) / var(--tw-bg-opacity, 1));
}

.aria-expanded\\:bg-secondary[aria-expanded="true"]{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--secondary) / var(--tw-bg-opacity, 1));
}

.aria-expanded\\:text-foreground[aria-expanded="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--foreground) / var(--tw-text-opacity, 1));
}

.aria-expanded\\:text-secondary-foreground[aria-expanded="true"]{
  --tw-text-opacity: 1;
  color: hsl(var(--secondary-foreground) / var(--tw-text-opacity, 1));
}

.dark\\:bg-destructive\\/20:is(.dark *){
  background-color: hsl(var(--destructive) / 0.2);
}

.dark\\:hover\\:bg-destructive\\/30:hover:is(.dark *){
  background-color: hsl(var(--destructive) / 0.3);
}

.dark\\:hover\\:bg-muted\\/50:hover:is(.dark *){
  background-color: hsl(var(--muted) / 0.5);
}

.dark\\:focus-visible\\:ring-destructive\\/40:focus-visible:is(.dark *){
  --tw-ring-color: hsl(var(--destructive) / 0.4);
}

.\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-3 svg:not([class*='size-']){
  width: 0.75rem;
  height: 0.75rem;
}

.\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-3\\.5 svg:not([class*='size-']){
  width: 0.875rem;
  height: 0.875rem;
}

.\\[\\&_svg\\:not\\(\\[class\\*\\=\\'size-\\'\\]\\)\\]\\:size-4 svg:not([class*='size-']){
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}

.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/global.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,sBAAc;EAAd,8DAAc;IAAd;AAAc;;AAAd;EAAA,kBAAc;EAAd,kEAAc;EAAd,oBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAEnB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;EACxB,mCAAmC;EACnC,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,qCAAqC;EACrC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;;EAEd,yCAAyC;EACzC,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB;;;;;GAKC;EACD,sCAAsC;EACtC,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;EACxB,mCAAmC;EACnC,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,qCAAqC;EACrC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAYA;;;EAGE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,8EAA8E;EAC9E,eAAe;EACf,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAHA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAFA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA,oDAAoD;AACpD;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW,YAAY,EAAE,sBAAsB,EAAE;EACjD,MAAM,UAAU,EAAE,sBAAsB,EAAE;AAC5C;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,mCAAmC,aAAa,EAAE;AAClD,kCAAkC,gBAAgB,EAAE;;AAEpD;;;;;;EAME,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;AACxC,uBAAuB,eAAe,EAAE;AACxC;;uBAEuB,eAAe,EAAE;;AAExC;;;;;;;;;;;;;EAaE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,4BAA4B,eAAe,EAAE;;AAE7C;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,oBAAoB;EACpB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAFA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;EAGE,+BAA+B;EAC/B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,qEAAqE;AACvE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA,+DAA+D;AAC/D;;EAEE,gCAAgC;AAClC;AAHA;;EAEE,gCAAgC;AAClC;;AAEA;;;EAIE,YAAY;EACZ,eAAe;AACjB;;AANA;;;;EAIE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,2BAA2B;AAC7B;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;EAC7B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mCAAmC;AACrC;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kGAAkG;EAClG,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,6EAA6E;AAC/E;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,4EAA4E;AAC5E;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;;AAttCA;EAAA,0BAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,0BAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,0BAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,0BAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,0BAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,0BAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,0BAutCA;EAvtCA,kBAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA,kBAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA,oBAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA,sBAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,8BAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,2GAutCA;EAvtCA,yGAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA,kBAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,kBAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,oBAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,oBAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA,cAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,eAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA,WAutCA;EAvtCA;AAutCA;;AAvtCA;EAAA;AAutCA;;AAvtCA;EAAA;AAutCA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --background: 210 38% 99%;\n  --foreground: 222 47% 11%;\n  --card: 0 0% 100%;\n  --card-foreground: 222 47% 11%;\n  --popover: 0 0% 100%;\n  --popover-foreground: 222 47% 11%;\n  --primary: 203 41% 41%;\n  --primary-foreground: 0 0% 100%;\n  --secondary: 210 33% 97%;\n  --secondary-foreground: 222 47% 11%;\n  --muted: 210 33% 97%;\n  --muted-foreground: 215 16% 47%;\n  --accent: 212 78% 95%;\n  --accent-foreground: 222 47% 11%;\n  --destructive: 0 84% 60%;\n  --destructive-foreground: 210 40% 98%;\n  --border: 214 24% 88%;\n  --input: 214 24% 88%;\n  --ring: 203 41% 41%;\n  --radius: 1rem;\n\n  /* Gridrive brand palette (teal → navy) */\n  --brand-light: #5d98b6;\n  --brand-main: #3d7292;\n  --brand-dark: #1b3e5a;\n  --brand-gradient: linear-gradient(\n    135deg,\n    var(--brand-light) 0%,\n    var(--brand-main) 50%,\n    var(--brand-dark) 100%\n  );\n  --brand-soft: rgba(61, 114, 146, 0.12);\n  --brand-soft-strong: rgba(61, 114, 146, 0.18);\n  --brand-pulse: rgba(61, 114, 146, 0.45);\n}\n\n.dark {\n  --background: 222 47% 7%;\n  --foreground: 210 40% 96%;\n  --card: 222 47% 10%;\n  --card-foreground: 210 40% 96%;\n  --popover: 222 47% 10%;\n  --popover-foreground: 210 40% 96%;\n  --primary: 201 42% 54%;\n  --primary-foreground: 0 0% 100%;\n  --secondary: 217 33% 17%;\n  --secondary-foreground: 210 40% 96%;\n  --muted: 217 33% 17%;\n  --muted-foreground: 215 20% 65%;\n  --accent: 217 33% 17%;\n  --accent-foreground: 210 40% 96%;\n  --destructive: 0 63% 31%;\n  --destructive-foreground: 210 40% 98%;\n  --border: 217 33% 20%;\n  --input: 217 33% 20%;\n  --ring: 201 42% 54%;\n}\n\n@layer base {\n  * {\n    @apply border-border;\n    box-sizing: border-box;\n  }\n  body {\n    @apply bg-background text-foreground;\n  }\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, system-ui, sans-serif;\n  font-size: 13px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n  font: inherit;\n}\n\n::placeholder {\n  color: hsl(var(--muted-foreground));\n  opacity: 1;\n}\n\n::selection {\n  background: rgba(59, 130, 246, 0.18);\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.45);\n  border: 2px solid transparent;\n  border-radius: 9999px;\n  background-clip: padding-box;\n}\n\n.dark ::-webkit-scrollbar-thumb {\n  background: rgba(71, 85, 105, 0.6);\n  background-clip: padding-box;\n}\n\n/* ── Split layout: table (top) + chat (bottom) ── */\n.setup-table-region {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.setup-table-region.setup-table-split {\n  flex: none;\n  max-height: 55%;\n  border-bottom: 1px solid hsl(var(--border));\n}\n\n.setup-chat-region {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.setup-table-region::-webkit-scrollbar {\n  width: 4px;\n}\n\n.setup-table-region::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.setup-table-region::-webkit-scrollbar-thumb {\n  background: hsl(var(--border));\n  border-radius: 2px;\n}\n\n.setup-table-region::-webkit-scrollbar-thumb:hover {\n  background: hsl(var(--muted-foreground));\n}\n\n/* ── Chat message layout ── */\n.message {\n  display: flex;\n  max-width: 100%;\n}\n\n.message.user {\n  justify-content: flex-end;\n}\n\n.message.assistant {\n  justify-content: flex-start;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.assistant-dot {\n  width: 7px;\n  height: 7px;\n  min-width: 7px;\n  border-radius: 50%;\n  background: var(--brand-gradient);\n  margin-top: 8px;\n}\n\n.assistant-dot.pulsing {\n  animation: dotGlow 2.4s ease-in-out infinite;\n}\n\n@keyframes dotGlow {\n  0%, 100% { opacity: 0.7; transform: scale(0.95); }\n  50% { opacity: 1; transform: scale(1.08); }\n}\n\n.assistant-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.bubble {\n  max-width: 88%;\n  padding: 10px 14px;\n  font-size: 13px;\n  line-height: 1.5;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.user-bubble {\n  width: fit-content;\n  background: #f5f5f5;\n  color: #111827;\n  border-radius: 14px 14px 4px 14px;\n  word-break: normal;\n}\n\n.dark .user-bubble {\n  background: hsl(var(--secondary));\n  color: hsl(var(--secondary-foreground));\n}\n\n.assistant-bubble {\n  background: transparent;\n  color: hsl(var(--foreground));\n  padding: 2px 0;\n}\n\n.assistant-bubble > :first-child { margin-top: 0; }\n.assistant-bubble > :last-child { margin-bottom: 0; }\n\n.assistant-bubble h1,\n.assistant-bubble h2,\n.assistant-bubble h3,\n.assistant-bubble h4,\n.assistant-bubble h5,\n.assistant-bubble h6 {\n  margin: 14px 0 8px;\n  line-height: 1.3;\n  font-weight: 700;\n}\n\n.assistant-bubble h1 { font-size: 20px; }\n.assistant-bubble h2 { font-size: 18px; }\n.assistant-bubble h3 { font-size: 16px; }\n.assistant-bubble h4,\n.assistant-bubble h5,\n.assistant-bubble h6 { font-size: 14px; }\n\n.assistant-bubble p + p,\n.assistant-bubble p + ul,\n.assistant-bubble p + ol,\n.assistant-bubble p + table,\n.assistant-bubble p + blockquote,\n.assistant-bubble ul + p,\n.assistant-bubble ol + p,\n.assistant-bubble table + p,\n.assistant-bubble blockquote + p,\n.assistant-bubble pre + p,\n.assistant-bubble ul + pre,\n.assistant-bubble ol + pre,\n.assistant-bubble hr + p {\n  margin-top: 10px;\n}\n\n.assistant-bubble ul,\n.assistant-bubble ol {\n  padding-left: 18px;\n  margin: 8px 0 0;\n}\n\n.assistant-bubble li + li { margin-top: 4px; }\n\n.assistant-bubble a {\n  color: var(--brand-main);\n  text-decoration: underline;\n}\n\n.assistant-bubble code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  background: rgba(17, 24, 39, 0.06);\n  border-radius: 4px;\n  padding: 1px 4px;\n}\n\n.assistant-bubble pre {\n  margin: 10px 0 0;\n  padding: 10px 12px;\n  background: hsl(var(--card));\n  border: 1px solid hsl(var(--border));\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.assistant-bubble pre code {\n  display: block;\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n  white-space: pre-wrap;\n}\n\n.assistant-bubble blockquote {\n  margin: 10px 0 0;\n  padding: 0 0 0 12px;\n  border-left: 3px solid hsl(var(--border));\n  color: hsl(var(--muted-foreground));\n}\n\n.assistant-bubble hr {\n  margin: 12px 0;\n  border: 0;\n  border-top: 1px solid hsl(var(--border));\n}\n\n.assistant-bubble table {\n  width: 100%;\n  margin: 10px 0 0;\n  border-collapse: collapse;\n  background: hsl(var(--card));\n  border: 1px solid hsl(var(--border));\n  border-radius: 8px;\n  overflow: hidden;\n  display: table;\n  max-width: 100%;\n  table-layout: auto;\n}\n\n.assistant-bubble thead th {\n  text-align: left;\n  padding: 7px 8px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  background: hsl(var(--muted));\n  border-bottom: 1px solid hsl(var(--border));\n}\n\n.assistant-bubble tbody td {\n  padding: 7px 8px;\n  vertical-align: top;\n  border-bottom: 1px solid hsl(var(--border));\n  font-size: 12px;\n}\n\n.assistant-bubble tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* ── Cycling \"thinking\" word (shimmers in brand color) ── */\n.thinking-word {\n  display: inline-block;\n  font-size: 13px;\n  font-style: italic;\n  padding: 2px 0;\n  color: transparent;\n  background: linear-gradient(\n    90deg,\n    var(--brand-main) 0%,\n    var(--brand-main) 30%,\n    #a8d4ec 50%,\n    var(--brand-main) 70%,\n    var(--brand-main) 100%\n  );\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  animation: shimmer 2.5s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n/* ── Chat layout (message area grows, input pinned to bottom) ── */\n.chat-container {\n  position: relative;\n  flex: 1 1 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.chat-empty-watermark {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  width: 96px;\n  height: auto;\n  transform: translate(-50%, -50%);\n  opacity: 0.08;\n  pointer-events: none;\n  user-select: none;\n}\n\n.chat-messages {\n  flex: 1 1 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  overflow-y: auto;\n  padding: 8px 10px;\n}\n\n/* ── Chat input (enclosed rounded box) ── */\n.chat-input-area {\n  flex-shrink: 0;\n  padding: 8px 10px 10px;\n  background: transparent;\n}\n\n.chat-input-enclosure {\n  display: flex;\n  flex-direction: column;\n  background: hsl(var(--card));\n  border: 1px solid hsl(var(--border));\n  border-radius: 14px;\n  padding: 6px 10px 6px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.chat-input-enclosure:focus-within {\n  border-color: var(--brand-main);\n  box-shadow: 0 0 0 3px var(--brand-soft);\n}\n\n.dark .chat-input-enclosure {\n  background: hsl(var(--card));\n}\n\n.chat-input-box {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  background: transparent;\n  padding: 0;\n}\n\n.chat-input-box textarea {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 13px;\n  font-family: inherit;\n  color: hsl(var(--foreground));\n  background: transparent;\n  min-width: 0;\n  resize: none;\n  line-height: 1.5;\n  max-height: 144px;\n  overflow-y: hidden;\n  padding: 6px 0;\n}\n\n.chat-input-box textarea::placeholder {\n  color: hsl(var(--muted-foreground));\n}\n\n.chat-input-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin: 2px 0 0;\n  padding: 0;\n}\n\n.chat-input-workbook-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 180px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background: var(--brand-soft);\n  color: var(--brand-main);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.4;\n  cursor: default;\n}\n\n.chat-input-mode-chip,\n.chat-input-snapshot-chip,\n.chat-input-template-context {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 150px;\n  min-height: 22px;\n  padding: 2px 8px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 9999px;\n  background: hsl(var(--background));\n  color: hsl(var(--muted-foreground));\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.chat-input-mode-chip {\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.chat-input-snapshot-chip {\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.chat-input-mode-picker {\n  position: relative;\n  display: inline-flex;\n}\n\n.chat-input-mode-chip:hover,\n.chat-input-mode-chip.active,\n.chat-input-snapshot-chip:hover {\n  border-color: var(--brand-main);\n  background: var(--brand-soft);\n  color: var(--brand-main);\n}\n\n.chat-input-mode-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-input-mode-chevron {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.chat-input-mode-popover {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 8px);\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: max-content;\n  min-width: 150px;\n  max-width: calc(100vw - 32px);\n  padding: 8px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 12px;\n  background: hsl(var(--popover));\n  color: hsl(var(--popover-foreground));\n  box-shadow: 0 16px 36px rgb(15 23 42 / 16%);\n}\n\n.chat-input-mode-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 34px;\n  padding: 6px 8px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: hsl(var(--foreground));\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.2;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.chat-input-mode-option:hover {\n  background: hsl(var(--secondary));\n}\n\n.chat-input-mode-option[aria-checked=\"true\"] {\n  color: hsl(var(--foreground));\n}\n\n.chat-input-mode-option span {\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.chat-input-mode-check {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  margin-left: 4px;\n}\n\n.chat-input-template-context {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-input-workbook-chip svg {\n  flex-shrink: 0;\n  display: block;\n}\n\n.chat-input-workbook-chip-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.chat-input-footer-left {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.chat-input-footer-right {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.chat-send-button {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 12px;\n  background: var(--brand-gradient);\n  color: #fff;\n  cursor: pointer;\n  transition: filter 0.15s ease, transform 0.15s ease, color 0.15s ease;\n}\n\n.chat-send-button:hover:not(:disabled) {\n  filter: brightness(1.15);\n}\n\n.chat-send-button.is-stop {\n  background: var(--brand-main);\n  color: #fff;\n}\n\n/* Dim the arrow when textarea is empty (placeholder visible) */\n.chat-input-area:has(textarea:placeholder-shown)\n  .chat-send-button:not(.is-stop):not(:disabled) {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.chat-input-area:has(textarea:placeholder-shown)\n  .chat-send-button:not(.is-stop):not(:disabled):hover,\n.chat-input-area:has(textarea:placeholder-shown)\n  .chat-send-button:not(.is-stop):not(:disabled):active {\n  filter: none;\n  transform: none;\n}\n\n.chat-send-button:active {\n  transform: translateY(1px);\n}\n\n.chat-send-button:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.chat-send-button svg {\n  display: block;\n}\n\n/* ── Snapshot metric pill + inline name input ── */\n.snapshot-metric-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: #fff;\n  background: var(--brand-gradient);\n  padding: 4px 10px;\n  border-radius: 9999px;\n  white-space: nowrap;\n}\n\n.snapshot-name-input {\n  width: 100px;\n  padding: 3px 6px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 6px;\n  font-size: 11px;\n  font-family: inherit;\n  background: hsl(var(--card));\n  color: hsl(var(--foreground));\n}\n\n.snapshot-name-input:focus {\n  outline: none;\n  border-color: var(--brand-main);\n  box-shadow: 0 0 0 2px var(--brand-soft);\n}\n\n/* ── Generic icon buttons (gear, shortcuts, trace) ── */\n.btn-icon {\n  background: none;\n  border: none;\n  font-size: 14px;\n  color: var(--brand-main);\n  cursor: pointer;\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border-radius: 6px;\n  line-height: 1;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.btn-icon:hover {\n  color: var(--brand-dark);\n  background: var(--brand-soft);\n}\n\n.btn-icon-gear {\n  font-size: 18px;\n  width: 32px;\n  height: 32px;\n}\n\n.chat-input-footer .btn-icon-gear {\n  font-size: 22px;\n  width: 28px;\n  height: 28px;\n}\n\n.btn-icon-shortcuts {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: hsl(var(--muted-foreground));\n  padding: 4px 6px;\n  border-radius: 6px;\n  line-height: 1;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.btn-icon-shortcuts svg {\n  display: block;\n  flex-shrink: 0;\n}\n\n.btn-icon-shortcuts:hover {\n  color: var(--brand-main);\n  background: var(--brand-soft);\n}\n\n.btn-trace {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: hsl(var(--muted-foreground));\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.btn-trace:hover {\n  color: var(--brand-main);\n  background: var(--brand-soft);\n}\n\n.chat-input-footer .snapshot-name-input {\n  width: 100px;\n  padding: 3px 6px;\n  font-size: 11px;\n}\n\n/* ── Fade-in reveal for finalized messages ── */\n.bubble.fade-in-reveal {\n  animation: fadeInReveal 0.4s ease-out both;\n}\n\n@keyframes fadeInReveal {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* ── Interim bubble (status messages during multi-step ops) ── */\n.interim-bubble {\n  font-style: italic;\n  color: hsl(var(--muted-foreground));\n  font-size: 12px;\n  padding: 2px 2px !important;\n}\n\n/* ── Metric Review Table (snapshot/scan results) ── */\n.metric-table-wrapper {\n  margin: 8px 0;\n  max-width: 100%;\n  overflow-x: auto;\n  flex-shrink: 0;\n}\n\n.metric-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  background: hsl(var(--card));\n  border: 1px solid hsl(var(--border));\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.metric-table thead th {\n  text-align: left;\n  padding: 6px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: hsl(var(--muted-foreground));\n  background: hsl(var(--muted));\n  border-bottom: 1px solid hsl(var(--border));\n  white-space: nowrap;\n}\n\n.metric-table tbody td {\n  padding: 4px 6px;\n  border-bottom: 1px solid hsl(var(--border));\n  vertical-align: middle;\n}\n\n.metric-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.metric-table tbody tr:hover {\n  background: hsl(var(--muted));\n}\n\n.mt-input {\n  width: 100%;\n  padding: 3px 5px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 12px;\n  font-family: inherit;\n  background: transparent;\n  color: hsl(var(--foreground));\n  transition: border-color 0.15s ease;\n}\n\n.mt-input:hover {\n  border-color: hsl(var(--border));\n}\n\n.mt-input:focus {\n  outline: none;\n  border-color: var(--brand-main);\n  background: hsl(var(--card));\n  box-shadow: 0 0 0 2px var(--brand-soft);\n}\n\n.mt-input:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.mt-cell {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  max-width: 100px;\n}\n\n.mt-sheet {\n  color: hsl(var(--muted-foreground));\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n/* ── Scan confidence pill (replacement for inline tailwind on FieldRow) ── */\n.scan-confidence-high {\n  color: #16a34a;\n}\n.scan-confidence-medium {\n  color: #d97706;\n}\n.scan-confidence-low {\n  color: hsl(var(--muted-foreground));\n}\n\n/* ── Tabbed scan table: wrapper ── */\n.tabbed-metric-table {\n  margin: 4px 0 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* ── Sheet tabs (pill row) ── */\n.sheet-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 2px 0 6px;\n  border-bottom: 1px solid hsl(var(--border));\n}\n\n.sheet-tab {\n  appearance: none;\n  background: transparent;\n  border: 1px solid transparent;\n  color: hsl(var(--muted-foreground));\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  border-radius: 9999px;\n  cursor: pointer;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.sheet-tab:hover {\n  color: var(--brand-main);\n  background: var(--brand-soft);\n}\n\n.sheet-tab.active {\n  color: #fff;\n  background: var(--brand-gradient);\n  border-color: transparent;\n}\n\n/* ── Category section (Assumptions / Outputs) ── */\n.category-section {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.category-header-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.category-header {\n  appearance: none;\n  background: transparent;\n  border: none;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 2px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: hsl(var(--foreground));\n  cursor: pointer;\n  text-align: left;\n  transition: color 0.15s ease;\n}\n\n.category-header:hover {\n  color: var(--brand-main);\n}\n\n.category-arrow {\n  color: hsl(var(--muted-foreground));\n  transition: transform 0.15s ease;\n}\n\n.category-arrow.open {\n  transform: rotate(90deg);\n}\n\n.category-label {\n  letter-spacing: 0.01em;\n}\n\n.category-count {\n  color: hsl(var(--muted-foreground));\n  font-weight: 500;\n  font-size: 11px;\n}\n\n.category-paint-button {\n  appearance: none;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: hsl(var(--muted-foreground));\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 28px;\n  width: 28px;\n  height: 28px;\n  padding: 3px;\n  transition: background 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease, transform 0.15s ease;\n  --color-1: #ef4444;\n  --color-2: #f97316;\n  --color-3: #22c55e;\n  --color-4: #3b82f6;\n  --color-5: #a855f7;\n}\n\n.category-paint-button.active {\n  background: rgb(15 23 42 / 5%);\n  box-shadow: 0 4px 10px rgb(15 23 42 / 12%);\n}\n\n.category-paint-button:not(.active) {\n  opacity: 0.48;\n}\n\n.category-paint-button:hover {\n  background: rgb(15 23 42 / 6%);\n  opacity: 1;\n  transform: translateY(-1px);\n}\n\n.category-paint-button.active:hover {\n  box-shadow: 0 5px 12px rgb(15 23 42 / 18%);\n}\n\n.category-paint-button:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px hsl(var(--background)), 0 0 0 4px rgb(59 130 246 / 35%);\n}\n\n.category-paint-button:not(.active) .rainbow-brush-icon {\n  filter: grayscale(0.85);\n}\n\n@keyframes rainbow-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── Metric table: Name-column hint + action cell + add/delete buttons ── */\n.metric-table th.mt-name,\n.metric-table td.mt-name {\n  min-width: 120px;\n}\n\n.metric-table th.mt-actions,\n.metric-table td.mt-actions {\n  width: 28px;\n  text-align: right;\n}\n\n.mt-delete {\n  appearance: none;\n  background: transparent;\n  border: none;\n  color: hsl(var(--muted-foreground));\n  padding: 4px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.mt-delete:hover {\n  color: hsl(var(--destructive));\n  background: rgba(220, 38, 38, 0.08);\n}\n\n.mt-add-row {\n  appearance: none;\n  width: 100%;\n  background: transparent;\n  border: 1px dashed hsl(var(--border));\n  border-radius: 8px;\n  color: hsl(var(--muted-foreground));\n  padding: 6px 8px;\n  font-size: 11px;\n  font-family: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.mt-add-row:hover {\n  color: var(--brand-main);\n  border-color: var(--brand-main);\n  background: var(--brand-soft);\n}\n\n/* ── Inline template table inside template chat ── */\n.template-table-artifact {\n  width: 100%;\n  min-width: 0;\n}\n\n.inline-fields-table {\n  width: 100%;\n  max-width: 100%;\n  margin: 4px 0 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.inline-fields-table-wrapper {\n  margin: 4px 0 8px;\n}\n\n.inline-metric-table {\n  table-layout: fixed;\n}\n\n.inline-metric-table th,\n.inline-metric-table td {\n  overflow: hidden;\n}\n\n.metric-table th.mt-sheet-cell,\n.metric-table td.mt-sheet-cell {\n  min-width: 86px;\n}\n\n.template-table-summary {\n  width: fit-content;\n  max-width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 8px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 8px;\n  background: hsl(var(--muted));\n  color: hsl(var(--muted-foreground));\n  font-size: 11px;\n  line-height: 1.3;\n}\n\n.template-table-summary span {\n  white-space: nowrap;\n}\n\n.template-table-summary-preview {\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.template-table-cancelled {\n  width: fit-content;\n  margin: 2px 0 6px;\n  color: hsl(var(--muted-foreground));\n  font-size: 11px;\n}\n\n.chat-template-artifact {\n  width: 100%;\n  max-width: 100%;\n  margin-top: 6px;\n}\n\n.chat-template-save-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.chat-template-name-input {\n  min-width: 0;\n  flex: 1;\n  height: 30px;\n  border: 1px solid hsl(var(--border));\n  border-radius: 6px;\n  background: hsl(var(--background));\n  padding: 0 8px;\n  color: hsl(var(--foreground));\n  font-size: 12px;\n}\n\n.chat-template-save-button {\n  flex-shrink: 0;\n  height: 30px;\n  border: none;\n  border-radius: 6px;\n  background: var(--brand-main);\n  padding: 0 10px;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chat-template-save-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.chat-template-saved-label {\n  width: fit-content;\n  margin-top: 6px;\n  color: hsl(var(--muted-foreground));\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
